import * as React from 'react'
import { useDriverForm } from '@/modules/drivers/context/DriverFormContext'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { DateField } from '@/ui/form/controls/DateField'
import { TextField } from '@/ui/form/controls/TextField'
import { FieldsetSelect } from '@/modules/settings/components/FieldsetSelect'
import { Checkbox } from '@/ui'
import { Divider } from '../../shared/Divider'

const PermissionsStage = () => {
  const { t } = useLocalize()
  const { data, setData, countriesOptions, countries } = useDriverForm()

  return (
    <div className="tw-flex tw-justify-between">
      <div className="tw-w-full tw-max-w-[256px]">
        <p className="tw-text-lg tw-font-semibold tw-text-content-base">
          {t('driverBasics.permissions')}
        </p>
      </div>
      <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-4">
        <TextField
          label={t('driverBasics.work-permit')}
          value={data?.workPermitNumber}
          onChange={(e) =>
            setData({ ...data, workPermitNumber: e.target.value })
          }
        />
        <div className="tw-flex tw-items-center tw-gap-4 tw-z-0">
          <DateField
            label={t('common.from')}
            value={data?.workPermitStartDate}
            setValue={(e) => setData({ ...data, workPermitStartDate: e })}
          />
          <DateField
            label={t('common.to')}
            value={data?.workPermitExpirationDate}
            setValue={(e) => setData({ ...data, workPermitExpirationDate: e })}
          />
        </div>

        <TextField
          label={t('driverBasics.issuing-authority')}
          value={data?.workPermitIssuingAuthority}
          onChange={(e) =>
            setData({ ...data, workPermitIssuingAuthority: e.target.value })
          }
        />
        <Divider />
        <div className="tw-flex tw-items-center tw-gap-2 tw-z-0">
          <Checkbox
            checked={data?.isA1CertificateIssued}
            onChange={(e) =>
              setData({ ...data, isA1CertificateIssued: e.target.checked })
            }
          />
          <p className="tw-m-0 tw-text-sm tw-text-content-base">
            {t('driverBasics.has-a1-certificate')}
          </p>
        </div>

        <TextField
          label={t('driverBasics.a1-certificate-number')}
          value={data?.a1CertificateNumber}
          onChange={(e) =>
            setData({ ...data, a1CertificateNumber: e.target.value })
          }
        />
        <FieldsetSelect
          label={t('driverBasics.a1-issuing-country')}
          placeholder={t('common.select')}
          value={data?.a1CertificateIssuer?.id?.toString() ?? ''}
          onChange={(e) => {
            const id = e.target.value

            const countryObj = Array.isArray(countries)
              ? countries.find((c) => c.id.toString() === id)
              : null

            setData({
              ...data,
              a1CertificateIssuer: countryObj ?? null,
            })
          }}
          options={countriesOptions}
        />

        <Divider />
        <TextField
          label={t('driverBasics.residence-permit')}
          value={data?.residencePermitNumber}
          onChange={(e) =>
            setData({ ...data, residencePermitNumber: e.target.value })
          }
        />
        <div className="tw-flex tw-items-center tw-gap-4 tw-z-0">
          <DateField
            label={t('common.from')}
            value={data?.residencePermitStartDate}
            setValue={(e) => setData({ ...data, residencePermitStartDate: e })}
          />
          <DateField
            label={t('common.to')}
            value={data?.residencePermitExpirationDate}
            setValue={(e) =>
              setData({ ...data, residencePermitExpirationDate: e })
            }
          />
        </div>
        <TextField
          label={t('driverBasics.issuing-authority')}
          value={data?.residencePermitIssuingAuthority}
          onChange={(e) =>
            setData({
              ...data,
              residencePermitIssuingAuthority: e.target.value,
            })
          }
        />
      </div>
    </div>
  )
}

export default PermissionsStage
